import { useEffect, useState } from 'react'
import { api } from '@/lib/api'

export default function MessagesAdmin() {
  const [rows, setRows] = useState([])

  const load = async () => {
    const { data } = await api.get('/contact')
    setRows(data.data || [])
  }

  useEffect(() => { load().catch(() => setRows([])) }, [])

  return (
    <div>
      <h1 className="text-2xl font-bold mb-6">Contact messages</h1>
      <div className="space-y-3">
        {rows.map((row) => (
          <div key={row.id} className="admin-glass rounded-2xl p-4">
            <div className="flex justify-between gap-4">
              <div>
                <p className="font-semibold">{row.name} · {row.email}</p>
                <p className="text-sm text-slate-400">{row.phone} · {row.subject}</p>
              </div>
              <button className="text-red-400" onClick={async () => { await api.delete(`/contact/${row.id}`); await load() }}>Delete</button>
            </div>
            <p className="mt-3 text-slate-200 whitespace-pre-wrap">{row.message}</p>
          </div>
        ))}
        {!rows.length && <p className="text-slate-400">No messages yet.</p>}
      </div>
    </div>
  )
}
